import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';
import ErrorPage from './pages/ErrorPage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/modal.css';
import { generateToken, messaging } from './notifications/firebase';
import { onMessage } from 'firebase/messaging';

import { AppStateProvider } from './context/AppStateContext';
import NoInternet from './components/NoInternet';

function App() {
  useEffect(() => {
    // Listen for foreground messages
    const unsubscribe = onMessage(messaging, (payload) => {
      const title = payload.notification?.title || "New Notification";
      const body = payload.notification?.body || "You have a new update.";

      // Use toast to show notification while app is in foreground
      toast.info(`${title}: ${body}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    });

    return () => unsubscribe();
  }, []);
  return (
    <>
      <NoInternet />
      {/* Minimal toast container - all styling handled by CSS */}
      <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={3}
      />
      <Router>
        <AppStateProvider>
          <Routes>
            {/* User Routes */}
            <Route path="/*" element={<UserLayout />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLayout />} />
            <Route path="/admin/*" element={<AdminLayout />} />

            {/* Error Route */}
            <Route path="/error" element={<ErrorPage />} />

            {/* Catch-all route */}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </AppStateProvider>
      </Router>
    </>
  );
}

export default App;
